import logo from "./logo.svg";
import "./App.css";
import Board from "./Components/Board/Board.js";
import Sidebar from "./Components/Sidebar/Sidebar";
import Home from "./Components/Home/Home";

function App() {
  return (
    <div className="App">
      <div className="container-fluid">
        <Home />
      </div>
      <Board />
    </div>
  );
}

export default App;
